const loaderElem = document.getElementById("custom-loader");

export const showLoader = () => {
  loaderElem.classList.remove("d-none");
};

export const hideLoader = () => {
  loaderElem.classList.add("d-none");
};

export const formatDate = (initialDate) => {
  initialDate = new Date(initialDate);

  const dateFormat = new Intl.DateTimeFormat("en", {
    timeStyle: "short",
    dateStyle: "medium",
  });

  const finalDate = dateFormat.format(initialDate);

  return finalDate.toString();
};

export const formatDateForFilter = (initialDate) => {
  initialDate = new Date(initialDate);

  const dateFormat = new Intl.DateTimeFormat("en", {
    dateStyle: "medium",
  });

  const finalDate = dateFormat.format(initialDate);
  
  return finalDate;
}


export const removeCommentsFromCss = (inputCss) => {
  const regexPattern = /\/\*[\s\S]*?\*\/|([^:]|^)\/\/.*$/gm;
  const outputCss = inputCss.replace(regexPattern, "");
  return outputCss;
};

export const toShowComponents = () => {
  const currentEngagement = localStorage.getItem("engagement");
  return ["BI", "VIFOR"].includes(currentEngagement);
};

export const handleImagesSort = (a, b) => {
  const imgNumA = a.replace("img-", "");
  const imgNumB = b.replace("img-", "");

  const intImgNumA = parseInt(imgNumA);
  const intImgNumB = parseInt(imgNumB);

  if (intImgNumA && intImgNumB) return intImgNumA - intImgNumB;
  else return a - b;
};

export const TAB_VIEWS = {
  DIFF: "diff",
  ACTUAL: "actual",
  BASELINE: "baseline",
};

export const APP_ENGAGEMENT_OPTS ={
  FETCHING_ENGAGEMENT_TEXT: "Fetching Engagement",
  FETCH_ENGAGEMENT_ERROR: "Error fetching Engagement! Contact Admin!!!"
}